import { SUBDOMAIN_BLACKLIST } from 'settings';

export const isSubdomain = (url: string = window.location.host) => {
  if (!url) return false;
  if (url.includes('http') || url.includes('/')) {
    url = new URL(url).host;
  }
  const splitHost: string[] = url.split('.');
  if (splitHost.length >= 1 && url.includes('.')) {
    const [subdomain] = splitHost;
    if (!SUBDOMAIN_BLACKLIST.includes(subdomain)) {
      return true;
    }
  }
  return false;
};
